module.exports = __webpack_public_path__ + "img/logo.688e6a52.png";